import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import FlexBox from 'components/FlexBox';
import HelpText from 'components/HelpText';
import messages from '../../messages';
import { Button } from '../../../components/Button';
import PageSectionHeader from '../../../components/PageSectionHeader';
import Textbox from '../../../components/Textbox';
import DatePicker from '../../../components/DatePicker/index';
import ErrorMessage from '../../../../../components/Validation/ErrorMessage';
import Validate from '../../../../../components/Validation/Validate';
import { optional, required } from '../../../../../utils/validation/validator';
import CurrencySelector from '../../../components/CurrencySelector';

export class CancellationExpensesListItem extends React.Component {
  onDayChange = (propertyName) => (date) => {
    const localDate = removeTimeZoneFromDate(date);
    const item = { ...this.props.item, ...{ [propertyName]: localDate } };
    this.change(item);
  };

  onChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };

  onRemoveClick = () => {
    if (this.props.onRemove) {
      this.props.onRemove(this.props.item.id);
    }
  };

  change = (item) => {
    if (this.props.onChange) {
      this.props.onChange(item);
    }
  };
  handleCurrencyChange = (propertyName) => (value) => {
    const item = { ...this.props.item, ...{ [propertyName]: value } };
    this.change(item);
  };
  render() {
    const {
      item,
      disabled,
      validatorGroup,
      validationCounter,
      removable,
    } = this.props;
    const refundFieldValidator =
      item.refundCompensationReceived > 0 ? required : optional;

    return (
      <div className="secondary-background expenses">
        <div className="row align-items-center">
          {!disabled &&
            removable && (
              <div className={'col-auto'}>
                <Button onClick={this.onRemoveClick}>Remove</Button>
              </div>
            )}
          <div className="col-auto">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.cancellationExpenseTitle}
                values={{ index: this.props.index + 1 }}
              />
            </PageSectionHeader>
          </div>
        </div>
        <div className={'row'}>
          <div className={'form-group col-md-3 col-sm-5'}>
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.dateCancelled}
                fieldName={messages.cancellationExpensesDateCancelled}
              >
                <DatePicker
                  disabled={disabled}
                  type="text"
                  onDayChange={this.onDayChange('dateCancelled')}
                  value={item.dateCancelled}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesDateCancelled}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className={'form-group col-md-5 col-sm-7'}>
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[required]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.cancelledBookingDescription}
              fieldName={
                messages.cancellationExpensesCancelledBookingDescription
              }
            >
              <Textbox
                disabled={disabled}
                type="text"
                onChange={this.onChange('cancelledBookingDescription')}
                value={item.cancelledBookingDescription}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={
                    messages.cancellationExpensesCancelledBookingDescription
                  }
                />
              </ErrorMessage>
            </Validate>

            <HelpText>
              <FormattedMessage
                {...messages.textBoxEg}
                values={{ value: 'Flight to Paris' }}
              />
            </HelpText>
          </div>
          <div className={'form-group col-md-4 col-sm-6'}>
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.supplier}
                fieldName={messages.cancellationExpensesSupplier}
              >
                <Textbox
                  disabled={disabled}
                  type="text"
                  onChange={this.onChange('supplier')}
                  value={item.supplier}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesSupplier}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Qantas' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-5 col-sm-7">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.prePaidAmount}
                fieldName={messages.cancellationExpensesPrePaidAmount}
              >
                <Textbox
                  disabled={disabled}
                  type="number"
                  onChange={this.onChange('prePaidAmount')}
                  value={item.prePaidAmount}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesPrePaidAmount}
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-3 col-sm-5">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[required]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.prePaidAmountCurrency}
                fieldName={messages.cancellationExpensesCurrency}
              >

                <CurrencySelector
                  name="rentalVehicleExcessAmountCurrency"
                  onChange={this.handleCurrencyChange('prePaidAmountCurrency')}
                  disabled={disabled}
                  value={item.prePaidAmountCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesCurrency}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-4 col-sm-5">
            <Validate
              validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
              group={validatorGroup}
              validators={[refundFieldValidator]}
              addValidatorToGroup={validatorGroup.addValidatorToGroup}
              validChangeInGroup={validatorGroup.validChangeInGroup}
              validationCounter={validationCounter}
              className="w-full"
              defaultValue={item.dateRefundWasReceived}
              fieldName={messages.dateRefundWasReceived}
            >
              <DatePicker
                disabled={disabled}
                type="text"
                onDayChange={this.onDayChange('dateRefundWasReceived')}
                value={item.dateRefundWasReceived}
                placeholder=""
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.dateRefundWasReceived}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>
        <div className="row">
          <div className="form-group col-md-5 col-sm-7">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[refundFieldValidator]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.refundCompensationReceived}
                fieldName={
                  messages.cancellationExpensesRefundCompensationReceived
                }
              >
                <Textbox
                  disabled={disabled}
                  type="number"
                  onChange={this.onChange('refundCompensationReceived')}
                  value={item.refundCompensationReceived}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={
                      messages.cancellationExpensesRefundCompensationReceived
                    }
                  />
                </ErrorMessage>
              </Validate>
            </FlexBox>
          </div>
          <div className="form-group col-md-3 col-sm-5">
            <FlexBox>
              <Validate
                validatorLeaveGroup={validatorGroup.removeValidatorToGroup}
                group={validatorGroup}
                validators={[refundFieldValidator]}
                addValidatorToGroup={validatorGroup.addValidatorToGroup}
                validChangeInGroup={validatorGroup.validChangeInGroup}
                validationCounter={validationCounter}
                className="w-full"
                defaultValue={item.refundCompensationReceivedCurrency}
                fieldName={messages.cancellationExpensesCurrency}
              >

                <CurrencySelector
                  name="rentalVehicleExcessAmountCurrency"
                  onChange={this.handleCurrencyChange('refundCompensationReceivedCurrency')}
                  disabled={disabled}
                  value={item.refundCompensationReceivedCurrency}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.cancellationExpensesCurrency}
                  />
                </ErrorMessage>
              </Validate>

              <HelpText>
                <FormattedMessage
                  {...messages.textBoxEg}
                  values={{ value: 'Euro' }}
                />
              </HelpText>
            </FlexBox>
          </div>
        </div>
      </div>
    );
  }
}

CancellationExpensesListItem.propTypes = {
  onChange: PropTypes.func,
  onRemove: PropTypes.func,
  item: PropTypes.object,
  index: PropTypes.number,
  removable: PropTypes.bool,
  disabled: PropTypes.bool,
  validatorGroup: PropTypes.object,
  validationCounter: PropTypes.number,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step10/components/CancellationExpenses/CancellationExpensesListItem.js